/**
 * @fileoverview Prompt template for world-element-image-creator-fal-v2.
 *
 * This is a simple passthrough template that just uses the image prompt directly.
 * The image prompt is typically generated by world-element-image-prompt-creator-v2.
 */

export const prompt = `{{{imagePrompt}}}`;
